import { render, staticRenderFns } from "./Headquarters.vue?vue&type=template&id=2d542bbf&"
import script from "./Headquarters.vue?vue&type=script&lang=ts&"
export * from "./Headquarters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports